var chroma = require('chroma-js');

const RECURSION_AMOUNT = -1;
const ADA_THRESHOLD = 4.5;

export function shiftColorShade(initialHexCode, amountToShift) {
  amountToShift *= 0.1; // scaling to maintain expected input

  if (amountToShift >= 0) {
    var tempColor = chroma(initialHexCode)
      .brighten(amountToShift)
      .hex();

    if (isThisContrastADACompliant(initialHexCode)) {
      //case: base case, no problem
      return tempColor;
    } else {
      //case: color is too light to shift up, shift down
      return shiftColorShade(initialHexCode, RECURSION_AMOUNT);
    }
  } else {
    return chroma(initialHexCode)
      .darken(Math.abs(amountToShift))
      .hex();
  }
}

export function determineFontColor(initialHexCode) {
  if (isThisContrastADACompliant(initialHexCode)) {
    return '#ffffff';
  } else {
    return '#000000';
  }
}

function isThisContrastADACompliant(initialHexCode) {
  return chroma.contrast(initialHexCode, '#ffffff') > ADA_THRESHOLD;
}
